import useResource from "web/hooks/data/useResource"
import API from "../api"

export default function useImportSheet({
  importId,
  sheetId,
  parentKeys,
  swrOptions = {},
}) {
  const key = `/imports/${importId}/sheets/${sheetId}`
  const [data] = useResource({ key, parentKeys, swrOptions })

  async function reprocess() {
    await API.post(`${key}/processes`)
    await data.refresh()
  }

  async function confirm() {
    await API.post(`${key}/confirmations`)
    await data.refresh()
  }

  data.reprocess = reprocess
  data.confirm = confirm

  return data
}
